import { Component, Inject } from '@angular/core';
import { CMPS_DIALOG_DATA } from '@cmps/ng-uikit';

import { PopulationGroupDialogData } from './model/population-group-dialog-data.model';
import { TranslationKeyMap } from './population-group-dialog.i18n';

@Component({
    selector: 'cmps-mi2-population-group-dialog',
    templateUrl: './population-group-dialog.component.html',
    host: {
        class: 'cmps-mi2-population-group-dialog',
    },
})
export class PopulationGroupDialogComponent {
    /** @private */ _i18n = TranslationKeyMap;

    constructor(
        @Inject(CMPS_DIALOG_DATA) /** @private */
        readonly _data: PopulationGroupDialogData,
    ) {}
}
